import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import styles from "./SubscriptionInProcess.module.css";

const SubscriptionInProcess = () => {
  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <FaCheckCircle className={styles.icon} />
        <h2>Your subscription has been processed</h2>
      </div>
    </div>
  );
};

export default SubscriptionInProcess;